export var toUnionType = function (props) {
    var values = props.values, defaultValue = props.defaultValue;
    return {
        isUnion: true,
        values: values || [],
        defaultValue: defaultValue || (values === null || values === void 0 ? void 0 : values[0]) || null,
    };
};
